export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const USER_LOCAL_STORAGE_KEY = "user";
export const ID_TOKEN_LOCAL_STORAGE_KEY = "id_token";
export const IS_DEMO_LOCAL_STORAGE_KEY = "isDemo";
export const IS_AIMODE_LOCAL_STORAGE_KEY = "isAIMode";
export const TOKEN_EXPIRY_TIME_LOCAL_STORAGE_KEY = "tokenExpiryTime";
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY = "refreshToken";

export const SESSION_TIME_OUT = 1000 * 3600 * 2;

export const REFETCH_INTERVAL = 1000 * 60; // 60 Second

export const HEADER_HEIGHT = 220;

export const DEFAULT_PER_PAGE = 50;

export const SNOWFLAKE_JDBC = "jdbc:snowflake://";
export const DATABRICKS_JDBC = "jdbc:databricks://";

export const SNOWFLAKE_DOMAIN = ".snowflakecomputing.com";
export const DATABRICKS_DOMAIN = ".cloud.databricks.com";

export const GOOGLE_ANALYTICS_ID = "G-XNP76MRCSZ";

export const SeverityColor = {
  critical: "var(--tlx-status-error-text)",
  high: "var(--tlx-status-error-text)",
  medium: "var(--tlx-status-warning-text)",
};

export const ChartsColors = [
  "var(--tlx-cta-primary-default)",
  "var(--tlx-color-dark_data)",
  "var(--tlx-status-warning-text)",
  "var(--tlx-color-sidebar-heading)",
  "var(--tlx-color-link-accent)",
  "var(--tlx-color-shadow_it)",
  "var(--tlx-color-data_exfiltration)",
  "var(--tlx-color-overly_granted_access)",
  "var(--tlx-color-regulatory_compliance)",
  "var(--tlx-color-security_misconfigurations)",
];
